import { CIcon } from '~/icons/types'

export const ciShare: CIcon = {
  width: '16',
  height: '16',
  paths: [
    {
      d:
        'M12 6.4a2.4 2.4 0 1 0-2.382-2.104L5.666 6.272a2.4 2.4 0 1 0 0 3.455l3.952 1.976a2.4 2.4 0 1 0 .716-1.431L6.382 8.296a2.424 2.424 0 0 0 0-.593l3.952-1.976A2.392 2.392 0 0 0 12 6.4Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'share',
  type: 'solid'
}
